import moment from 'moment';

export const convertSecondToTime = (totalSeconds: number) => {
    let hours: any = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    if (hours < 10) {
        hours = '0' + hours;
    }
    return `${hours}:${('0' + minutes).slice(-2)}:${('0' + seconds).slice(-2)}`;
};

export const numberWithCommas = (e: any) => {
    return e
        .toString()
        .replace(/\D/g, '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const timeOneMonth = 30 * 24 * 60 * 60 * 1000; // 30 days milisecond
export const convertTitleTimeAgo = (time: string | Date) => {
    if (new Date().getTime() - new Date(time).getTime() > timeOneMonth) {
        return moment(time).format('DD/MM/YYYY');
    } else {
        return moment(new Date(time)).fromNow();
    }
};

export const convertMoneyTxt = (money: number) => {
    let moneyConvertStr = '';
    if (money < 1000) {
        moneyConvertStr = `${money}`;
    } else if (money >= 1000 && money < 1000000) {
        moneyConvertStr = `${money / 1000}K`;
    } else if (money >= 1000000) {
        moneyConvertStr = `${money / 1000000}M`;
    }
    return moneyConvertStr;
}

export const getDateTimeHH_MM_SS = (date: any) => {
    let hour = date.getHours();
    if (hour < 10) {
        hour = `0${hour}`;
    }
    let minute = date.getMinutes();
    if (minute < 10) {
        minute = `0${minute}`;
    }
    let second = date.getSeconds();
    if (second < 10) {
        second = `0${second}`;
    }
    return `${hour}:${minute}:${second}`;
}

export const getDateTimeDD_MM_YYYY = (date: any) => {
    let day = date.getDate();
    if (day < 10) {
        day = `0${day}`;
    }
    let month = date.getMonth() + 1;
    if (month < 10) {
        month = `0${month}`;
    }
    return `${day}/${month}/${date.getFullYear()}`;
}
